// Generated by Melange

import * as Buhta_landing__Link from "../../components/html/Link.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function DocsTopbar(Props) {
  const match = React.useState(function () {
    return false;
  });
  const setMenuActive = match[1];
  const menuActive = match[0];
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const language = Buhta_landing__Route.getLanguage(undefined);
  const hidden = menuActive ? "" : "hidden";
  let routeName;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    routeName = "";
  } else {
    switch (currentRoute._2) {
      case /* Home */ 0 :
        routeName = "Home";
        break;
      case /* Kassa */ 1 :
        routeName = "Касса";
        break;
      case /* Post */ 2 :
        routeName = "Financial reports";
        break;
    }
  }
  let homeColor;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    homeColor = "text-black-landing";
  } else {
    switch (currentRoute._2) {
      case /* Home */ 0 :
        homeColor = "text-primary-variant";
        break;
      case /* Kassa */ 1 :
      case /* Post */ 2 :
        homeColor = "text-black-landing";
        break;
    }
  }
  let kassaColor;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    kassaColor = "text-black-landing";
  } else {
    switch (currentRoute._2) {
      case /* Kassa */ 1 :
        kassaColor = "text-primary-variant";
        break;
      case /* Home */ 0 :
      case /* Post */ 2 :
        kassaColor = "text-black-landing";
        break;
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/search.svg")
            }),
            JsxRuntime.jsx("input", {
              className: "paragraph-small ml-1 text-black-landing placeholder-gray-landing",
              placeholder: "Поиск",
              type: "text"
            })
          ],
          className: "bg-white p-2 lg:p-0 flex items-center rounded"
        }),
        className: "py-4 w-full"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "Войти",
            className: "paragraph-small-medium text-primary-variant"
          }),
          JsxRuntime.jsxs("button", {
            children: [
              JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/forward.svg")
              }),
              JsxRuntime.jsx("p", {
                children: "Зарегистироваться",
                className: "paragraph-small-medium text-white ml-1"
              })
            ],
            className: "flex bg-primary-variant items-center ml-3 px-3 py-2 rounded"
          })
        ],
        className: "lg:flex items-center hidden"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: routeName,
            className: "paragraph-large text-black-landing"
          }),
          JsxRuntime.jsx("img", {
            alt: "dropdown",
            src: menuActive ? StaticAsset.src("/static/icons/dropdown-up-20.svg") : StaticAsset.src("/static/icons/dropdown-down-20.svg")
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Docs */ 1,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: /* Home */ 0
                },
                className: "paragraph-large " + homeColor + " py-2 border-b border-divider",
                onLinkClicked: (function (param) {
                  Curry._1(setMenuActive, (function (param) {
                    return false;
                  }));
                }),
                children: "Home"
              }),
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Docs */ 1,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: /* Kassa */ 1
                },
                className: "paragraph-large " + kassaColor + " py-2 border-b border-divider",
                onLinkClicked: (function (param) {
                  Curry._1(setMenuActive, (function (param) {
                    return false;
                  }));
                }),
                children: "Касса"
              })
            ],
            className: "absolute z-10 top-10 bg-bg w-screen -left-6 px-6 pb-6 " + hidden + " flex flex-col"
          })
        ],
        className: "flex lg:hidden bg-bg justify-between items-center py-2.5 relative",
        onClick: (function (param) {
          Curry._1(setMenuActive, (function (param) {
            return !menuActive;
          }));
        })
      })
    ],
    className: "px-6 bg-bg lg:bg-white lg:border-b lg:border-divider lg:flex justify-between"
  });
}

const make = DocsTopbar;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
